module.exports = __webpack_public_path__ + "2acb60f2/img/lock-icon.bb9c7166.svg";